"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _uuid = require("uuid");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var checkedIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  fill: "currentColor",
  focusable: "false",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}));

var DxcCheckbox = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      value = _ref.value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? "before" : _ref$labelPosition,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      onChange = _ref.onChange,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fitContent" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)("label-checkbox-".concat((0, _uuid.v4)())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      labelId = _useState2[0];

  var _useState3 = (0, _react.useState)(defaultChecked),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerChecked = _useState4[0],
      setInnerChecked = _useState4[1];

  var checkboxRef = (0, _react.useRef)(null);
  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var handleCheckboxChange = function handleCheckboxChange() {
    var _checkboxRef$current;

    document.activeElement !== (checkboxRef === null || checkboxRef === void 0 ? void 0 : checkboxRef.current) && (checkboxRef === null || checkboxRef === void 0 ? void 0 : (_checkboxRef$current = checkboxRef.current) === null || _checkboxRef$current === void 0 ? void 0 : _checkboxRef$current.focus());
    var newChecked = checked !== null && checked !== void 0 ? checked : innerChecked;
    checked !== null && checked !== void 0 ? checked : setInnerChecked(function (innerChecked) {
      return !innerChecked;
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(!newChecked);
  };

  var handleKeyboard = function handleKeyboard(event) {
    switch (event.key) {
      case " ":
        event.preventDefault();
        handleCheckboxChange();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.checkbox
  }, /*#__PURE__*/_react["default"].createElement(MainContainer, {
    disabled: disabled,
    onClick: disabled ? undefined : handleCheckboxChange,
    margin: margin,
    size: size,
    checked: checked !== null && checked !== void 0 ? checked : innerChecked,
    backgroundType: backgroundType,
    ref: ref
  }, label && labelPosition === "before" && /*#__PURE__*/_react["default"].createElement(LabelContainer, {
    id: labelId,
    disabled: disabled,
    backgroundType: backgroundType
  }, label, optional && " ".concat(translatedLabels.formFields.optionalLabel)), /*#__PURE__*/_react["default"].createElement(ValueInput, {
    type: "checkbox",
    checked: checked !== null && checked !== void 0 ? checked : innerChecked,
    name: name,
    "aria-hidden": "true",
    value: value,
    disabled: disabled,
    readOnly: true
  }), /*#__PURE__*/_react["default"].createElement(CheckboxContainer, null, /*#__PURE__*/_react["default"].createElement(Checkbox, {
    onKeyDown: handleKeyboard,
    role: "checkbox",
    tabIndex: disabled ? -1 : tabIndex,
    "aria-checked": checked !== null && checked !== void 0 ? checked : innerChecked,
    "aria-disabled": disabled,
    "aria-required": !disabled && !optional,
    "aria-labelledby": labelId,
    backgroundType: backgroundType,
    checked: checked !== null && checked !== void 0 ? checked : innerChecked,
    disabled: disabled,
    ref: checkboxRef
  }, (checked !== null && checked !== void 0 ? checked : innerChecked) && checkedIcon)), label && labelPosition === "after" && /*#__PURE__*/_react["default"].createElement(LabelContainer, {
    id: labelId,
    disabled: disabled,
    backgroundType: backgroundType
  }, optional && "".concat(translatedLabels.formFields.optionalLabel, " "), label)));
});

var sizes = {
  small: "120px",
  medium: "240px",
  large: "480px",
  fillParent: "100%",
  fitContent: "fit-content"
};

var calculateWidth = function calculateWidth(margin, size) {
  if (size === "fillParent") {
    return "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
  }

  return sizes[size];
};

var getDisabledColor = function getDisabledColor(props, element) {
  switch (element) {
    case "check":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledCheckColorOnDark : props.theme.disabledCheckColor;

    case "background":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledBackgroundColorCheckedOnDark : props.theme.disabledBackgroundColorChecked;

    case "border":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledBorderColorOnDark : props.theme.disabledBorderColor;

    case "label":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.disabledFontColorOnDark : props.theme.disabledFontColor;
  }
};

var getEnabledColor = function getEnabledColor(props, element) {
  switch (element) {
    case "check":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.checkColorOnDark : props.theme.checkColor;

    case "background":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.backgroundColorCheckedOnDark : props.theme.backgroundColorChecked;

    case "hoverBackground":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.hoverBackgroundColorCheckedOnDark : props.theme.hoverBackgroundColorChecked;

    case "border":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.borderColorOnDark : props.theme.borderColor;

    case "hoverBorder":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.hoverBorderColorOnDark : props.theme.hoverBorderColor;

    case "label":
      return props.backgroundType && props.backgroundType === "dark" ? props.theme.fontColorOnDark : props.theme.fontColor;
  }
};

var LabelContainer = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.disabled ? getDisabledColor(props, "label") : getEnabledColor(props, "label");
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontWeight;
});

var ValueInput = _styledComponents["default"].input(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: none;\n"])));

var CheckboxContainer = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n"])));

var Checkbox = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 18px;\n  width: 18px;\n  border: 2px solid\n    ", ";\n  border-radius: 2px;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus {\n    outline: 2px solid\n      ", ";\n    outline-offset: 2px;\n  }\n  svg {\n    position: absolute;\n    width: 22px;\n    height: 22px;\n  }\n  ", "\n"])), function (props) {
  return props.disabled ? getDisabledColor(props, "border") : getEnabledColor(props, "border");
}, function (props) {
  return props.checked ? props.disabled ? getDisabledColor(props, "check") : getEnabledColor(props, "check") : "transparent";
}, function (props) {
  return props.disabled ? getDisabledColor(props, "background") : getEnabledColor(props, "background");
}, function (props) {
  return props.backgroundType === "dark" ? props.theme.focusColorOnDark : props.theme.focusColor;
}, function (props) {
  return props.disabled && "pointer-events: none;";
});

var MainContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  cursor: ", ";\n\n  &:hover ", " {\n    border: 2px solid\n      ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.checkLabelSpacing;
}, function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, Checkbox, function (props) {
  return props.disabled ? getDisabledColor(props, "border") : getEnabledColor(props, "hoverBorder");
}, function (props) {
  return props.checked ? props.disabled ? getDisabledColor(props, "check") : getEnabledColor(props, "check") : "transparent";
}, function (props) {
  return props.disabled ? getDisabledColor(props, "background") : getEnabledColor(props, "hoverBackground");
});

var _default = DxcCheckbox;
exports["default"] = _default;